<template>
  <section :class="['business-service', { 'business-service-gray': isBgGray }]" id="business-payments">
    <div class="business-inner">
      <div class="business-copy">
        <p class="eyebrow">Skyline</p>
        <h2>{{ $t('services.Business') }}</h2>
        <p>{{ $t('services.BusinessText') }}</p>
        <p>{{ $t('services.BusinessRequirements') }}</p>
        <div class="business-actions">
          <router-link :to="$siteLink('/business-payments')" class="business-button">{{ $t('products.BusinessLink') }}</router-link>
          <router-link :to="$siteLink('/contact')" class="business-link">{{ $t('services.DiscussBusiness') }}</router-link>
        </div>
      </div>
      <img class="business-image" src="@/assets/img/business.png" alt="" />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isBgGray: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.business-service { color: #163257; background: #fff; }
.business-service-gray { background: #f5f5f5; }
.business-inner { max-width: 1440px; margin: 0 auto; padding: clamp(36px, 7vw, 100px); display: grid; grid-template-columns: 1fr 1fr; gap: clamp(32px, 5vw, 72px); align-items: center; }
.business-copy { min-width: 0; }
.business-image { display: block; width: 100%; height: auto; }
.eyebrow { color: #8a6e29; font-size: 18px; font-weight: 600; }
h2 { margin: 12px 0 24px; color: #163257; font-size: clamp(26px, 2.8vw, 38px); line-height: 1.35; text-wrap: balance; font-weight: 600; }
p { margin: 0 0 20px; font-size: 17px; line-height: 1.75; }
.business-button { display: inline-flex; align-items: center; justify-content: center; margin-top: 8px; padding: 13px 28px; border-radius: 30px; background: #163257; color: #fff; font-size: 16px; line-height: 1.5; text-align: center; }
.business-button:hover { background: #244971; }
.business-actions { display: flex; flex-wrap: wrap; align-items: center; gap: 16px 24px; }
.business-link { display: inline-flex; align-items: center; min-height: 44px; color: inherit; text-decoration: underline; text-underline-offset: 5px; font-weight: 600; }
@media (max-width: 768px) {
  .business-inner { grid-template-columns: 1fr; padding: 36px 6vw; gap: 28px; }
  p { font-size: 16px; }
}
</style>
